import {
  AccountsApi,
  APIKeyApi,
  BlocksApi,
  Configuration,
  ContractApi,
  DeveloperApi,
  LoginHistoryApi,
  QuotesApi,
  TokensApi,
  TransactionsApi,
  WatchAddressApi,
} from "./api";

const configuration: Configuration = new Configuration({
  basePath: process.env.REACT_APP_PUBLIC_API_URL,
  baseOptions: {
    withCredentials: true,
  },
});

export const blockApi: BlocksApi = new BlocksApi(configuration);
export const accountApi: AccountsApi = new AccountsApi(configuration);
export const quoteApi: QuotesApi = new QuotesApi(configuration);
export const transactionApi: TransactionsApi = new TransactionsApi(
  configuration
);
export const tokenApi: TokensApi = new TokensApi(configuration);
export const developerApi: DeveloperApi = new DeveloperApi(configuration);
export const loginHistoryApi: LoginHistoryApi = new LoginHistoryApi(
  configuration
);
export const apiKeyApi: APIKeyApi = new APIKeyApi(configuration);
export const watchAddressApi: WatchAddressApi = new WatchAddressApi(
  configuration
);
export const contractApi: ContractApi = new ContractApi(configuration);
